import React, { useState } from "react";

import { Card, Col, Row, Nav, NavDropdown, Navbar } from "react-bootstrap";
import { DotsThree } from "phosphor-react";

import "./OwnProducts.scss";
import OtpActivationModal from "components/common/modals/otpActivationModal/OtpActivationModal";
import { otpActivation } from "services/ProductsServices";
import { useTranslation } from "react-i18next";
const Products = ({ productList, handleRefresh }) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [prod, setProd] = useState(null);
  const handleConfirm = async (productId, prevStatus) => {
    let v = new Boolean(!prevStatus).toString();
    let payload = [{ op: "replace", path: "TwoFactorEnabled", value: v }];
    await otpActivation(payload, productId);
    setShow(false);
    handleRefresh();
  };
  const handleShow = () => {
    setShow(true);
  };
  const handleSetProduct = (product) => {
    setProd(product);
  };
  return (
    <>
      <div className="own-products">
        {productList.length !== 0 &&
          productList.map((product) => {
            return (
              <Card className="product-card mb-2" key={product.productKey}>
                <Row>
                  <Col lg={12} className="d-flex flex-row align-items-center">
                    <img
                      src={`/assets/icons${product?.imageUrl}`}
                      className="me-3"
                    />
                    <h3>{t("products-list." + product?.translatedValue)}</h3>
                  </Col>
                  <div className="d-flex flex-wrap justify-content-between">
                    <div className="d-flex flex-row align-items-center detail">
                      <p className="me-2">
                        <span className="heading">{t("type")}</span>
                        <br />
                        <span className="value">{product?.type}</span>
                      </p>
                      <p className="me-2">
                        <span className="heading">{t("branches")}</span>
                        <br />
                        <span className="value">{product?.branchesCount}</span>
                      </p>
                      <p className="me-2 register">
                        <span className="heading">{t("registered-users")}</span>
                        <br />
                        <span className="value">{product?.usersCount}</span>
                      </p>
                      {/* <p className="revenue">
                        <span className="heading">{t("revenue-model")}</span>
                        <br />
                        <span className="value">{t(product?.revenueTranslatedValue)}</span>
                      </p> */}
                    </div>
                    <div className="d-flex flex-wrap flex-grow-1 align-items-center detail btn-container">
                      <a
                        href={
                          ["#Gecco", "#Esg"].includes(product.productKey)
                            ? product?.redirectUrl.replace(/\/$/, "") + "/main"
                            : product?.redirectUrl
                        }
                        target={"_blank"}
                      >
                        <button>{t("visit-landing-page")}</button>
                      </a>
                      {JSON.parse(localStorage.getItem("userRole"))?.roleName ==
                        "#IA" && product.productKey == "#FutureCare" ? (
                        <Navbar
                          bg="white"
                          expand="lg"
                          style={{ display: "contents" }}
                        >
                          <div>
                            <Navbar.Toggle aria-controls="navbar-dark-example" />
                            <Navbar.Collapse>
                              <Nav>
                                <NavDropdown
                                  title={
                                    <DotsThree
                                      width={50}
                                      r={25}
                                      size={20}
                                      className="icon"
                                    />
                                  }
                                >
                                  <NavDropdown.Item
                                    onClick={() => {
                                      handleShow();
                                      handleSetProduct(product);
                                    }}
                                  >
                                    {product?.twoFactorEnabled
                                      ? t("disable-otp")
                                      : t("enable-otp")}
                                  </NavDropdown.Item>
                                </NavDropdown>
                              </Nav>
                            </Navbar.Collapse>
                          </div>
                        </Navbar>
                      ) : (
                        <DotsThree
                          width={50}
                          r={25}
                          size={20}
                          className="icon"
                        />
                      )}
                    </div>
                  </div>
                </Row>
              </Card>
            );
          })}
      </div>
      <OtpActivationModal
        style={{ dataBackdrop: "static", dataKeyboard: "false" }}
        show={show}
        onHide={() => setShow(false)}
        handleConfirm={() =>
          handleConfirm(prod?.productId, prod?.twoFactorEnabled)
        }
        heading={`Are you sure that you want to ${
          prod?.twoFactorEnabled ? "disable" : "enable"
        } OTP`}
      />
    </>
  );
};

export default Products;
